import { render, staticRenderFns } from "./ResponderModerno.vue?vue&type=template&id=90f3c01a&scoped=true"
import script from "./ResponderModerno.vue?vue&type=script&lang=js"
export * from "./ResponderModerno.vue?vue&type=script&lang=js"
import style0 from "./ResponderModerno.vue?vue&type=style&index=0&id=90f3c01a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90f3c01a",
  null
  
)

export default component.exports